import React, { useEffect, useMemo, useState } from "react";
import { Route } from "react-router";
import Header from "../../component/frontend/Header";
import Footer from "../../component/frontend/Footer";
import banner_img from "../../images/banner-profile.jpg";
import services from "../../assets/data/services.json";
import { Link } from "react-router-dom";
import Seo from "../Seo";
import { Helmet } from "react-helmet";
import tableData from "../../../public/assets/data/table_data.json";
import { scAxiosAdmin } from "../..";
const Corporateclient = () => {
  // State for the search query
  const [searchQuery, setSearchQuery] = useState("");
  const [videoLInk, setVideoLInk] = useState({});
  useEffect(() => {
    const getAllBanner = (data) => {
      try {
        const req = scAxiosAdmin
          .request("/settings/30", {
            method: "get",
          })
          .then((data) => {
            if (data.status === 200) {
              setVideoLInk(data.data.value);
            }
          })
          .catch((e) => {
            console.log("your log output", e);
          });
      } catch (error) {}
    };
    getAllBanner();
  }, []);
  // Function to handle search query input change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  // Function to filter table data based on the search query
  // Memoized filtering function
  const filteredData = useMemo(() => {
    return Object.entries(tableData).reduce((filtered, [category, rows]) => {
      const filteredRows = rows.filter((row) =>
        row.name.toLowerCase().includes(searchQuery)
      );
      if (filteredRows.length > 0) {
        filtered[category] = filteredRows;
      }
      return filtered;
    }, {});
  }, [tableData, searchQuery]);

  return (
    <div>
      <Seo
        title="Corporate Clients | Best Hospital in Bangladesh | United Hospital"
        description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        pathSlug="/"
        keywords="Corporate Clients"
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            name: "United Hospital Limited",
            image:
              "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
            telephone: "10666",
            email: "info@uhlbd.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "plot 15, Road 71, Gulshan",
              addressLocality: "Dhaka",
              addressRegion: "Dhaka",
              addressCountry: "Bangladesh",
              postalCode: "1212",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              opens:
                "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
            },
            url: "http://www.uhlbd.com/",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "3.9",
              bestRating: "5",
              worstRating: "1",
              ratingCount: "756",
            },
            review: {
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "abdul kahar",
              },
              datePublished: "2019-02-12",
              reviewRating: {
                "@type": "Rating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
              },
              reviewBody:
                "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
            },
          })}
        </script>
        <meta
          name="Subject"
          content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
        />
        <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
        <meta name="Googlebot" content="all" />
        <meta http-equiv="imagetoolbar" content="no" />
        <meta name="robots" content="index, follow" />
        <meta name="copyright" content="Copyright &copy; uhlbd.com" />
        <meta name="owner" content="United Hospital" />
        <meta name="author" content="dcastalia.com" />
        <meta name="Rating" content="General" />
        <meta name="distribution" content="Global" />
        <meta
          name="classification"
          content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta
          names="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
        <meta name="msvalidate.01" content="16C4E0B16E39354E550F64BD707F6A97" />
      </Helmet>
      <Route component={Header} />
      <div id="giveMargin" className="" style={{ backgroundColor: "#fef3e9" }}>
        <img src={banner_img} alt="banner-profile" className="w-100" />
        <div class="">
          <section className="termscondbody mt-5 pb-5">
            <div className="container">
              <div className="box-of-about border-section mb-4">
                <div className="row g-2">
                  <div className="col-lg-8 col-md-12">
                    <div className="">
                      <div className=" bg-light p-3">
                        CORPORATE CLIENTS LOGO
                        <img
                          src="/assets/images/partner-img.jpg"
                          alt=""
                          width={"100%"}
                        />
                      </div>
                      <div className="my-4 d-flex flex-column flex-md-row justify-content-center justify-content-md-between align-items-center">
                        <h4>Corporate Client</h4>
                        <button
                          // disabled={cartData.length > 0 ? false : true}
                          type="button"
                          style={{ backgroundColor: "#187979", color: "white" }}
                          className="btn-sm rounded rounded-lg invBtn border-0 p-2"
                          data-bs-dismiss="offcanvas"
                          aria-label="Close"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#corporateRequestOffcanvasRight"
                          aria-controls="corporateRequestOffcanvasRight"
                        >
                          Request for Corporate Client Agreement
                        </button>
                      </div>
                      <div className="my-4">
                        <input
                          type="text"
                          placeholder="Search by name..."
                          value={searchQuery}
                          onChange={handleSearchChange}
                          className="search-bar rounded-pill"
                          style={{
                            padding: "8px",
                            width: "100%",
                            borderRadius: "5px",
                            border: "1px solid #ccc",
                          }}
                        />
                      </div>

                      <div className="bg-light p-3">
                        {Object.entries(filteredData).map(
                          ([category, rows], index) => (
                            <table className="table_style4" key={index}>
                              <tbody>
                                <tr>
                                  {/* <td>SL. No.</td> */}
                                  <td>{category}</td>
                                </tr>

                                {rows.map((rowData, rowIndex) => (
                                  <tr key={rowIndex}>
                                    {/* <td>{rowIndex + 1}</td> */}
                                    <td>{rowData.name}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          )
                        )}
                        {/* {Object.entries(tableData).map((table, index) => (
                          <table className="table_style4">
                            {console.log("mytable", table)}
                            <tbody>
                              <tr>
                                <td>SL. No.</td>
                                <td>{table[0]}</td>
                              </tr>
                              {table[1].map((tableData, index) => (
                                <tr>
                                  <td>{index + 1}</td>
                                  <td>{tableData.name}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ))} */}
                        <p>&nbsp;</p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-lg-4 col-md-12 d-none d-md-block pt-2"
                    style={{
                      backgroundColor: "#fff",
                      borderRadius: "5px",
                    }}
                  >
                    <div className="text-profile" id="mobile-part">
                      <div id="sidebar-2" className="row">
                        <div className="col-md-12 sidebar-item ">
                          <a
                            className="category-list-link open-cat-list"
                            href="#"
                          >
                            Select Services
                          </a>
                          <ul
                            className="list-unstyled category-list patients-category-list"
                            id="department-list-sidebar"
                          >
                            {services &&
                              services.map((item) => (
                                <Link
                                  to={`/pages/${item.slug}`}
                                  style={{ textDecoration: "none" }}
                                >
                                  <li>
                                    <a className="">{item.department_name}</a>
                                  </li>
                                </Link>
                              ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div
                      className="bookarea mt-3 d-none d-md-block mb-3"
                      style={{ position: "sticky", zIndex: "3333", top: 100 }}
                    >
                      <iframe
                        width="100%"
                        height="315"
                        src={videoLInk}
                        // src="https://www.youtube.com/embed/qG9oD9qxX6g"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; muted"
                        allowfullscreen
                      ></iframe>
                      <h5
                        className="text-center p-2 text-light"
                        style={{
                          backgroundColor: "#f58220",
                          marginTop: "-6px",
                        }}
                      >
                        Call Emergency Line
                        <br />
                        10666
                      </h5>
                      <img
                        src={
                          "https://www.uhlbd.com/resources/images/contact.jpg"
                        }
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Route component={Footer} />
    </div>
  );
};

export default Corporateclient;



// WEBPACK FOOTER //
// ./src/component/frontend/Corporateclient.js